import React, { useState, useEffect } from "react";
import debounce from "lodash.debounce";
import cx from "classnames";
import { func, object, arrayOf, string, bool } from "prop-types";
import AnimateHeight from "react-animate-height";

import { selectedFacetShape } from "../../common/dynamicSearch.js";

import FilterDropdown from "../FilterDropdown/FilterDropdown.jsx";

import ArrowLink from "../ArrowLink/ArrowLink.jsx";
import FilterDropdownSingle from "../FilterDropdown/FilterDropdownSingle.jsx";

const propTypes = {
  filterTitle: string,
  filterLabel: string,
  facets: arrayOf(object).isRequired,
  link: object,
  selectedFacets: selectedFacetShape.isRequired,
  onFacetChange: func.isRequired,
  onClearFacetGroup: func.isRequired,
  singleSelect: bool,
  accordionOpen: bool,
};

const FilterBar = (props) => {
  const {
    filterTitle,
    filterLabel,
    facets,
    onFacetChange,
    link,
    selectedFacets,
    onClearFacetGroup,
    singleSelect,
    accordionOpen = true,
  } = props;

  const [isAccordionOpen, setIsAccordionOpen] = useState(accordionOpen);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(() => {
      setWindowWidth(window.innerWidth);
    }, 100);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <section className="filter-bar">
      {windowWidth < 780 && (
        <button
          className={cx("btn fitler-bar__mobile-accordion-btn", {
            "fitler-bar__mobile-accordion-btn--is-open": isAccordionOpen,
          })}
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          type="button"
          aria-expanded={isAccordionOpen}
          data-gtm-element="dcl mobile filters accordion button"
        >
          {filterTitle ? filterTitle : "Filters"}
        </button>
      )}
      <AnimateHeight
        duration={500}
        height={
          windowWidth >= 780
            ? "auto"
            : windowWidth < 780 && isAccordionOpen
              ? "auto"
              : 0
        }
      >
        <div className="filter-bar__filter-menus">
          {facets &&
            facets.map((facet) => {
              return singleSelect ? (
                <FilterDropdownSingle
                  key={facet.id}
                  {...facet}
                  filterLabel={filterLabel}
                  onFacetChange={onFacetChange}
                />
              ) : (
                <FilterDropdown
                  key={facet.id}
                  {...facet}
                  filterLabel={filterLabel}
                  onClearFacetGroup={onClearFacetGroup}
                  selectedFacets={selectedFacets}
                  onFacetChange={onFacetChange}
                />
              );
            })}
        </div>
      </AnimateHeight>

      {link && link.href && (
        <div className="filter-bar__link">
          <ArrowLink {...link} gtmElementLabel="dcl filter bar link" />
        </div>
      )}
    </section>
  );
};

FilterBar.propTypes = propTypes;
export default FilterBar;
